var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 50,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#FF0000",
    fillOpacity: 0.43
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7075 32.6845C20.3175 33.0745 19.6835 33.0745 19.2935 32.6845L12.8075 26.1985C12.6115 26.0025 12.5135 25.7445 12.5155 25.4885C12.5155 25.2305 12.6115 24.9745 12.8075 24.7785L19.2935 18.2925C19.6835 17.9025 20.3175 17.9025 20.7075 18.2925C21.0975 18.6825 21.0975 19.3165 20.7075 19.7065L14.9255 25.4885L20.7075 31.2705C21.0975 31.6605 21.0975 32.2945 20.7075 32.6845Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/Left Arrow.183b971b261e494a01dda2c96c1a3fb4.svg";
export { ForwardRef as ReactComponent };